//node_modules
import React, { FunctionComponent } from "react";
import { NextSeo } from "next-seo";

//helpers
import getImageLoaderAbsoluteSrc from "@adjust/website/libs/helper/getImageLoaderAbsoluteSrc";

//hooks
import useCanonical from "@adjust/src/hooks/useCanonical";

const title = "Press - Adjust to the Good Life Travel";
const description = "Here is a list of places that we've been mentioned from all over the internet!";

const MetaComponent: FunctionComponent = () => {
  const canonical = useCanonical();
  const src = getImageLoaderAbsoluteSrc("/images/3a09d58794098791c474322bf5cca573.png", 1200);

  return (
    <>
      <NextSeo
        title={title}
        description={description}
        canonical={canonical}
        noindex={false}
        nofollow={false}
        openGraph={{
          type: "website",
          siteName: "Adjust to the Good Life Travel",
          url: canonical,
          title: title,
          description: description,
          images: [
            {
              url: src,
            },
          ],
        }}
        twitter={{
          cardType: "summary_large_image",
        }}
      />
    </>
  );
};

export default React.memo(MetaComponent);
